import {useMutation, useQuery, useQueryClient} from "react-query";
import {
    blueprintCategory,
    createTeFromSf,
    demoEnv,
    pillars,
    updateTeFromSf,
    userDetails
} from "../../../../../../../utils/const/query-key";
import apiService from "../../../../../../../api/apiService";
import styled from "styled-components";
import FilterSearch from "./FilterSearch";
import BluePrint from "./BluePrint";
import Box from "@mui/material/Box";
import {
    PILLARS_AMOUNT,
    usercenterUser
} from "../../../../../../../utils/const/createEnvConsts";
import StepperContext from "../StepperContext";
import {useContext, useEffect, useRef, useState} from "react";
import EnvironmentContext from "../../EnvironmentContext";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import ModalContext from "../../../../envResultsTable/ModalContext";
import Loading from "../../../../../Loading";
import {getEnvironmentURL} from "../../EnvironmentUtils";
import {TechnicalEngagementLinkUtil} from "../../../../envResultsTable/TechnicalEngagementLinkUtil";
import {useLocation} from "react-router-dom";
import {customTheme} from "../../../../../IntReports/LocationTab";
import Select from "react-select";
import {CheckboxOption} from "./CustomReactSelectComponents/CheckboxOption";
import {CustomMenuList} from "./CustomReactSelectComponents/CustomMenueList";
import {CustomValueContainer} from "./CustomReactSelectComponents/CustomValueContainer";
import {Tabs} from "react-tabs";



const Button = styled.button`
  width: 75px;
  height: 36px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: var(--color-table-even);
    color: var(--color-brand-pink-primary);
  }

  &.next {
    background: var(--unnamed-color-ec407a);
    background: var(--color-brand-pink-primary);
    color: var(--color-workspace-bg-page-area);
    border-radius: 2px;
    margin-right: 17px;

    ${props => props.disabled ? 'pointer-events: none;' : ''}
    ${props => props.disabled ? 'background: var(--unnamed-color-ec407a) ;' : ''}
    ${props => props.disabled ? 'background: #f1d8df;' : ''}
    &:hover {
      background: var(--color-createenv-stepper-next-btn-bg-hover);
    }
  }
`;

export const TabsStyled = styled(Tabs)`
  .selected {
    color: var(--color-brand-pink-primary);
    border-color: var(--color-brand-pink-primary);
    background-color: var(--color-brand-pink-light-selected);
    outline: none;
  }
`;

const ScrollBlueprintList = styled.ul`
  width: 615px;
  height: 450px;
  overflow: auto;
  margin-bottom: 20px;
  padding: 0px;

  &::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
    background: #EFEFEF;
  }

  &::-webkit-scrollbar-thumb {
    background: #838383;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #777676;
  }
`;

const StepContainer = styled.div`
  display: flex;
`;

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;  
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`;


const BluePrintCategoriesRow = (props) => {
    const bluePrints = props.bpData;
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [environmentData, setEnvironmentData] = useState("");
    const [isStaticEnv, setIsStaticEnv] = useState(false);
    const queryClient = useQueryClient();
    const userData = queryClient.getQueryData(userDetails);
    const {activeStep, handleBack} = useContext(StepperContext);
    const {environment, setEnvironment} = useContext(EnvironmentContext);
    const [selectedBlueprintId, setSelectedBlueprintId] = useState(null);
    const location = useLocation();

    const [pillarSelected, setPillarSelected] = useState([]);
    const [draftPillar, setDraftPillar] = useState([]);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const isClearingRef = useRef(false);

    const handlePillarChange = (newValue, actionMeta) => {
        const val = newValue || [];
        setDraftPillar(val);
        if (actionMeta.action === 'clear') {
            isClearingRef.current = true;
            setPillarSelected([]);
            setTimeout(() => { isClearingRef.current = false; }, 0);
        }
    };

    // Clear blueprint selection when leaving step 3
    useEffect(() => {
        return () => {
            if (activeStep === 2) {
                setEnvironment(prevState => ({
                    ...prevState,
                    blueprint_id: "",
                    category: ""
                }));
                setSelectedBlueprintId(null);
            }
        };
    }, [activeStep, setEnvironment]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const blueprintIdFromUrl = Number(params.get("blueprintId"));
        const blueprint = bluePrints?.find(
            bp => bp.id === blueprintIdFromUrl && !bp.disabledForUser
        );
        setSelectedBlueprintId(blueprint ? blueprintIdFromUrl : null);

        if (blueprint) {
            setEnvironment(prevState => ({
                ...prevState,
                blueprint_id: blueprint.id,
                category: blueprint.category,
            }));
        }
    }, [location.search, bluePrints, setEnvironment]);

    const {technicalEngagement, setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const {
        contentMessage,
        setBasicModalIsOpen,
        setEnvUrl,
        setContentMessage,
        setFailedSalesForceModalIsOpen,
        setIsInvitation
    } = useContext(ModalContext);

    const {data: blueprintCategoryData} = useQuery(blueprintCategory, () =>
            apiService.getBlueprintCategoryData(),
        {staleTime: Infinity}
    );
    const {data: pillarsData} = useQuery(pillars, () =>
        apiService.getPillars()
    );
    const {
        refetch: refetchCreateTechnicalEngagement,
        isFetching: isFetchingCreateTechnicalEngagment
    } = useQuery(createTeFromSf, () =>
            apiService.createTechnicalEngagement(technicalEngagement),
        {enabled: false}
    );
    const {
        refetch: refetchUpdateTechnicalEngagement,
        isFetching: isFetchingUpdateTechnicalEngagement
    } = useQuery(updateTeFromSf, () =>
            apiService.updateTechnicalEngagement(technicalEngagement),
        {enabled: false}
    );
    const {mutate: createEnv, isLoading} = useMutation((environment) => apiService.createEnvironment(environment),
        {
            onSuccess: (data) => {
                setEnvironmentData(data);
                if (data.status === null) {
                    queryClient.invalidateQueries(demoEnv);
                    const environmentLink = getEnvironmentURL(data);
                    setEnvUrl(environmentLink);
                    if (data.cloudType === "STATIC") {
                        setIsStaticEnv(true);
                    }
                    if (technicalEngagement.accountName !== "" && !technicalEngagement.partner) {
                        setTechnicalEngagement(prevState => ({
                            ...prevState,
                            dueDate: moment(data.createdOn).format("YYYY-MM-DD"),
                            environmentId: data.id,
                            subject: technicalEngagement.technicalEngagementId === null
                                ? "DemoPoint Auto Generated " + moment(data.createdOn).format("YYYY-MM-DD")
                                : null
                        }));
                    } else {
                        if (data.inviteCustomer) {
                            setIsInvitation(true);
                            setContentMessage(["Your Demo Environment has been created successfully and shared with " + data.customerEmail]);
                            setBasicModalIsOpen(true);
                        } else if (data.cloudType === "STATIC") {
                            setContentMessage([data.blueprint, data.message, data.cloudType, true]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully"]);
                            setBasicModalIsOpen(true);
                        }
                    }
                } else {
                    setContentMessage(["Failed to create DemoPoint Environment, Please Try Again Later"]);
                    setBasicModalIsOpen(true);
                }
            },
            onError: (error) => {
                const errorData = JSON.parse(error.message);
                if (errorData.status === 503) {
                    setContentMessage([errorData.message]);
                    setBasicModalIsOpen(true);
                }
            }
        }
    );

    const validBlueprintCategory = blueprintCategoryData?.filter(pillar => pillar.isvalid);

    // Sync category from URL into pillar dropdown (runs once when category data is ready)
    const didSetInitialFilter = useRef(false);
    useEffect(() => {
        if (!didSetInitialFilter.current && validBlueprintCategory) {
            const params = new URLSearchParams(location.search);
            const categoryFromUrl = params.get("category");
            if (categoryFromUrl) {
                const match = validBlueprintCategory.find(
                    bp => bp.name.toLowerCase() === categoryFromUrl.toLowerCase()
                );
                if (match) {
                    const option = {label: match.name, value: match.id};
                    setPillarSelected([option]);
                    setDraftPillar([option]);
                }
            }
            didSetInitialFilter.current = true;
        }
    }, [validBlueprintCategory, location.search]);

    useEffect(() => {
        let res;
        if (technicalEngagement.dueDate !== "") {
            if (technicalEngagement.technicalEngagementId !== null) {
                res = refetchUpdateTechnicalEngagement();
                res.then(result => {
                    if (result.data.ok) {
                        if (isStaticEnv) {
                            setContentMessage(["Your DemoPoint Environment has been synced successfully", <span>to SalesForce <a href={TechnicalEngagementLinkUtil(technicalEngagement)} target="_blank" rel="noreferrer">#{technicalEngagement.technicalEngagementId}</a> </span>, environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.ok]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully, ", <span>and synced to SalesForce Technical Engagement  <a href={TechnicalEngagementLinkUtil(technicalEngagement)} target="_blank" rel="noreferrer">#{technicalEngagement.technicalEngagementId}</a></span>]);
                            setBasicModalIsOpen(true);
                        }
                    } else {
                        if (isStaticEnv) {
                            setContentMessage(["Failed to sync your demo to SalesForce Technical Engagement.", "Please try to create it manually in Salesforce", environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully, ", "Failed to sync SalesForce Technical Engagement. Please try to create it manually in Salesforce"]);
                            setFailedSalesForceModalIsOpen(true);
                        }
                    }
                });
            } else {
                res = refetchCreateTechnicalEngagement();
                res.then(result => {
                    if (result.data.success) {
                        if (isStaticEnv) {
                            setContentMessage(["Your DemoPoint Environment has been synced successfully", <span>to SalesForce <a href={result.data.link} target="_blank" rel="noreferrer">#{result.data.id}</a> </span>, environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully ", <span>and synced to SalesForce Technical Engagement  <a href={result.data.link} target="_blank" rel="noreferrer">#{result.data.id}</a></span>]);
                            setBasicModalIsOpen(true);
                        }
                    } else {
                        if (isStaticEnv) {
                            setContentMessage(["Failed to create SalesForce Technical Engagement.", "Please try to create it manually in Salesforce", environmentData.blueprint, environmentData.message, environmentData.cloudType, result.data.success]);
                            setBasicModalIsOpen(true);
                        } else {
                            setContentMessage(["Your Demo Environment has been created successfully ", "Failed to create SalesForce Technical Engagement. Please try to create it manually in Salesforce"]);
                            setFailedSalesForceModalIsOpen(true);
                        }
                    }
                });
            }
        }
    }, [technicalEngagement, environmentData.blueprint, environmentData.cloudType, environmentData.message, isStaticEnv, refetchCreateTechnicalEngagement, refetchUpdateTechnicalEngagement, setBasicModalIsOpen, setContentMessage, setFailedSalesForceModalIsOpen]);

    useEffect(() => {
        if (contentMessage !== "") {
            navigate("/demo-point");
        }
    }, [contentMessage, navigate]);

    if (isLoading || isFetchingUpdateTechnicalEngagement || isFetchingCreateTechnicalEngagment) {
        return <Loading/>;
    }

    const handleBlueprintClick = (id, category, subPillar, name) => {
        setSelectedBlueprintId(id);
        setEnvironment(prevState => ({
            ...prevState,
            blueprint_id: id,
            category: category,
            salesforceOpportunityID: prevState.salesforceAccountID !== "" ? technicalEngagement.opportunity : prevState.salesforceOpportunityID,
        }));
        if (pillarsData.length === PILLARS_AMOUNT) {
            setTechnicalEngagement(prevState => ({
                ...prevState,
                pillar: pillarsData?.filter(pillar => pillar.name.toLowerCase() === category.toLowerCase()).length > 0 ? category : null,
                subPillar: subPillar,
                blueprintName: name
            }));
        }
    };

    const createEnvironment = () => {
        if (technicalEngagement.partner) {
            createEnv({
                ...environment,
                te_partner: technicalEngagement.partner,
                te_partnerEmail: technicalEngagement.partnerEmail,
            });
        } else {
            createEnv(environment);
        }
    };

    const matchBlueprintIcon = (category) => {
        return validBlueprintCategory?.filter(bp => bp.name === category);
    };

    // Filter blueprints by the committed pillarSelected + search text
    const filterBlueprintsByCategory = () => {
        let filterBp;
        if (environment.is_invitation) {
            filterBp = bluePrints?.filter(bp => bp.userRole.id === usercenterUser);
        } else {
            filterBp = bluePrints;
        }

        const selectedNames = pillarSelected.map(p => p.label);

        return filterBp?.filter(bp => {
            if (selectedNames.length > 0 && !selectedNames.includes(bp.category)) return false;
            if (search !== "" &&
                !bp.name.toLowerCase().includes(search.toLowerCase())) return false;
            return true;
        }).map(bp => {
            const bpIcon = matchBlueprintIcon(bp.category);
            return (
                <BluePrint
                    name={bp.name} description={bp.description} key={bp.id} bp={bp}
                    handleBlueprintClick={handleBlueprintClick} bpIcon={bpIcon[0]?.icon}
                    cloudTypeId={bp.cloudTypeId} userData={userData} selected={bp.id === selectedBlueprintId}
                />
            );
        });
    };

    const allOptions = validBlueprintCategory?.map(p => ({label: p.name, value: p.id})) || [];

    return (
        <div id={"blueprint-selection-step"}>
            <FiltersWrapper>
                <Select
                    isMulti={true}
                    menuIsOpen={menuIsOpen}
                    onMenuOpen={() => {
                        if (isClearingRef.current) return;
                        setDraftPillar(pillarSelected);
                        setMenuIsOpen(true);
                    }}
                    onMenuClose={() => {
                        // discard uncommitted changes when clicking outside
                        setDraftPillar(pillarSelected);
                        setMenuIsOpen(false);
                    }}
                    placeholder="Filter By Pillar"
                    theme={customTheme}
                    options={allOptions}
                    value={draftPillar}
                    onChange={handlePillarChange}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    components={{Option: CheckboxOption, MenuList: CustomMenuList, ValueContainer: CustomValueContainer}}
                    styles={{
                        container: base => ({...base, width: 300, height:36}),
                        valueContainer: base => ({...base, flexWrap: 'nowrap'}),
                        input: base => ({...base, flex: '0 0 auto'}),
                    }}
                    // custom props forwarded to components via selectProps
                    categoryData={validBlueprintCategory}
                    onSelectAll={() => setDraftPillar(allOptions)}
                    onClearAll={() => setDraftPillar([])}
                    onSave={() => {
                        setPillarSelected(draftPillar);
                        setMenuIsOpen(false);
                    }}
                    onCancel={() => {
                        setDraftPillar(pillarSelected);
                        setMenuIsOpen(false);
                    }}
                    id={"pillar_dropdown"}
                />
                <FilterSearch search={search} setSearch={setSearch}/>
            </FiltersWrapper>

            <ScrollBlueprintList id={"blueprint-list"}>
                {filterBlueprintsByCategory()}
            </ScrollBlueprintList>

            <Box sx={{mb: 2}}>
                <StepContainer>
                    <Button
                        className={'next'}
                        sx={{mt: 1, mr: 1}}
                        disabled={environment.blueprint_id === ""}
                        onClick={createEnvironment}
                    >
                        Submit
                    </Button>
                    {environment.customer_company_name.includes("CPX") ?
                        <Button
                            id={"cancelCpxBtn"}
                            onClick={() => navigate("/demo-point")}
                            sx={{mt: 1, mr: 1}}
                        >
                            Cancel
                        </Button>
                        : <Button
                            id={"back"}
                            onClick={handleBack}
                            sx={{mt: 1, mr: 1}}
                        >
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>
                    }
                </StepContainer>
            </Box>
        </div>
    );
};

export default BluePrintCategoriesRow;
